import { PrivacyCenterModule, type PrivacyCenterModuleContext } from './types';

/** web worker safe version of this map, need to keep imports to a minimum */
export const PRIVACY_CENTER_MODULE_CONTEXT_MAP_WORKER: Record<
  PrivacyCenterModule,
  PrivacyCenterModuleContext
> = {
  [PrivacyCenterModule.PrivacyCenter]: {
    operationName: 'PrivacyCenter',
    endpoint: undefined,
    moduleFilename: 'privacyCenter',
    versionColumnName: 'privacyCenterModule',
    localized: false,
  },
  [PrivacyCenterModule.Policies]: {
    operationName: 'PrivacyCenterPolicies',
    endpoint: undefined,
    moduleFilename: 'privacyCenterPolicies',
    versionColumnName: 'policiesModule',
    localized: true,
  },
  [PrivacyCenterModule.Messages]: {
    operationName: 'PrivacyCenterTranslatedMessages',
    endpoint: undefined,
    moduleFilename: 'privacyCenterMessages',
    versionColumnName: 'messagesModule',
    localized: true,
  },
  [PrivacyCenterModule.Subjects]: {
    operationName: 'PrivacyCenterSubjects',
    endpoint: undefined,
    moduleFilename: 'privacyCenterSubjects',
    versionColumnName: 'subjectsModule',
    localized: false,
  },
  [PrivacyCenterModule.RequestsProcessedStats]: {
    operationName: 'RequestsProcessedDisclosureStats',
    endpoint: undefined,
    moduleFilename: 'requestsProcessedDisclosureStats',
    versionColumnName: 'privacyCenterRequestsProcessedStatsModule',
    localized: false,
  },
  [PrivacyCenterModule.Purposes]: {
    operationName: 'PrivacyCenterPurposes',
    endpoint: undefined,
    moduleFilename: 'privacyCenterPurposes',
    versionColumnName: 'purposesModule',
    localized: false,
  },
  [PrivacyCenterModule.WorkflowConfigs]: {
    operationName: 'PrivacyCenterWorkflows',
    endpoint: undefined,
    moduleFilename: 'privacyCenterWorkflowConfigs',
    versionColumnName: 'privacyCenterWorkflowConfigsModule',
    localized: false,
  },
};
